import request from '../request'

//积分记录
export const UserCdKeyIndexRequest = p => {
    return request({
        method:'GET',
        url:'UserCdKey/index',
        params: p
    })
}